var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M16 72H432C440.837 72 448 64.837 448 56V16C448 7.163 440.837 0 432 0H16C7.163 0 0 7.163 0 16V56C0 64.837 7.163 72 16 72ZM16 232H432C440.837 232 448 224.837 448 216V176C448 167.163 440.837 160 432 160H16C7.163 160 0 167.163 0 176V216C0 224.837 7.163 232 16 232ZM16 392H432C440.837 392 448 384.837 448 376V336C448 327.163 440.837 320 432 320H16C7.163 320 0 327.163 0 336V376C0 384.837 7.163 392 16 392Z"}));
}

Menu.defaultProps = {"width":"448","height":"392","fill":"none","aria-label":"menu","viewBox":"0 0 448 392"};

module.exports = Menu;

Menu.default = Menu;
